import { useCulture } from 'context/CultureContext';

const getCert = () => {
    const { culture } = useCulture();

    if (culture === 'es-ar') {
        const Logo1 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo01.webp');
        const Logo2 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo02.webp');
        const Logo3 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo03.webp');
        const Logo4 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo04.webp');
        const Logo5 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo05.webp');

        return [
            {
                img: Logo1,
                alt: 'Icono data fiscal',
                link: 'https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcxMDc2OTg3M11bdGlwb2RvbWljaWxpbz0xXVtzZWN1ZW5jaWE9MV19&iad=%2F7rOgR8z%2BuK%2FTckyvLoFIzTgC6nvMKEglgV8CaiDwNa5RR6O554KXO6dIUc2LihK%2BgmA2KdbNP3qtZM0Fshl5Q%3D%3D',
                width: 35,
                height: 42
            },
            {
                img: Logo2,
                alt: 'Icono PDP',
                link: 'https://www.argentina.gob.ar/aaip/datospersonales',
                width: 70,
                height: 42
            },
            {
                img: Logo3,
                alt: 'Icono SSN',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 57,
                height: 42
            },
            {
                img: Logo4,
                alt: 'Icono godaddy',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 155,
                height: 42
            },
            {
                img: Logo5,
                alt: 'Icono econfianza',
                link: 'https://www.econfianza.org/ar/?c=minisitio&s=319',
                width: 110,
                height: 42
            }
        ];
    } else if (culture === 'es-mx') {
        const Logo1 = require('static/img/cert-logos/es-mx/aws-mx.png');
        const Logo2 = require('static/img/cert-logos/es-mx/cnsf-mx.png');
        const Logo3 = require('static/img/cert-logos/es-mx/getgeotrustsslseal.png');

        return [
            {
                img: Logo1,
                alt: 'Logo certificación AWS',
                width: 135,
                link: 'https://aws.amazon.com/es/',
                height: 60
            },
            {
                img: Logo2,
                alt: 'Logo CNSF',
                link: 'https://www.gob.mx/cnsf',
                width: 174,
                height: 60
            },
            {
                img: Logo3,
                alt: 'Logo GeoTrust',
                link: 'https://www.geotrust.com/es',
                width: 114,
                height: 55
            }
        ];
    } else if (culture === 'pt-br') {
        const Logo1 = require('static/img/cert-logos/pt-br/comodo.png');
        const Logo2 = require('static/img/cert-logos/pt-br/jucesp.png');
        const Logo3 = require('static/img/cert-logos/pt-br/protecao.png');
        const Logo4 = require('static/img/cert-logos/pt-br/susep.png');

        return [
            {
                img: Logo1,
                alt: 'Logo COMODO',
                link: 'https://ssl.comodo.com/',
                width: 103,
                height: 60
            },
            {
                img: Logo2,
                alt: 'Logo JUCESP',
                link: 'http://www.institucional.jucesp.sp.gov.br/',
                width: 75,
                height: 50
            },
            {
                img: Logo3,
                alt: 'Logo PROTECAO',
                link: 'http://pensando.mj.gov.br/dadospessoais/',
                width: 63,
                height: 47
            },
            {
                img: Logo4,
                alt: 'Logo SUSEP',
                link: 'http://novosite.susep.gov.br/',
                width: 156,
                height: 50
            }
        ];
    } else if (culture === 'es-cl') {
        const Logo1 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo01.webp');
        const Logo2 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo02.webp');
        const Logo3 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo03.webp');
        const Logo4 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo04.webp');
        const Logo5 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo05.webp');

        return [
            {
                img: Logo1,
                alt: 'Icono data fiscal',
                link: 'https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcxMDc2OTg3M11bdGlwb2RvbWljaWxpbz0xXVtzZWN1ZW5jaWE9MV19&iad=%2F7rOgR8z%2BuK%2FTckyvLoFIzTgC6nvMKEglgV8CaiDwNa5RR6O554KXO6dIUc2LihK%2BgmA2KdbNP3qtZM0Fshl5Q%3D%3D',
                width: 35,
                height: 42
            },
            {
                img: Logo2,
                alt: 'Icono PDP',
                link: 'https://www.argentina.gob.ar/aaip/datospersonales',
                width: 70,
                height: 42
            },
            {
                img: Logo3,
                alt: 'Icono SSN',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 57,
                height: 42
            },
            {
                img: Logo4,
                alt: 'Icono godaddy',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 155,
                height: 42
            },
            {
                img: Logo5,
                alt: 'Icono econfianza',
                link: 'https://www.econfianza.org/ar/?c=minisitio&s=319',
                width: 110,
                height: 42
            }
        ];
    } else if (culture === 'es-co') {
        const Logo1 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo01.webp');
        const Logo2 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo02.webp');
        const Logo3 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo03.webp');
        const Logo4 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo04.webp');
        const Logo5 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo05.webp');

        return [
            {
                img: Logo1,
                alt: 'Icono data fiscal',
                link: 'https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcxMDc2OTg3M11bdGlwb2RvbWljaWxpbz0xXVtzZWN1ZW5jaWE9MV19&iad=%2F7rOgR8z%2BuK%2FTckyvLoFIzTgC6nvMKEglgV8CaiDwNa5RR6O554KXO6dIUc2LihK%2BgmA2KdbNP3qtZM0Fshl5Q%3D%3D',
                width: 35,
                height: 42
            },
            {
                img: Logo2,
                alt: 'Icono PDP',
                link: 'https://www.argentina.gob.ar/aaip/datospersonales',
                width: 70,
                height: 42
            },
            {
                img: Logo3,
                alt: 'Icono SSN',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 57,
                height: 42
            },
            {
                img: Logo4,
                alt: 'Icono godaddy',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 155,
                height: 42
            },
            {
                img: Logo5,
                alt: 'Icono econfianza',
                link: 'https://www.econfianza.org/ar/?c=minisitio&s=319',
                width: 110,
                height: 42
            }
        ];
    } else if (culture === 'es-uy') {
        const Logo1 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo01.webp');
        const Logo2 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo02.webp');
        const Logo3 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo03.webp');
        const Logo4 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo04.webp');
        const Logo5 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo05.webp');

        return [
            {
                img: Logo1,
                alt: 'Icono data fiscal',
                link: 'https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcxMDc2OTg3M11bdGlwb2RvbWljaWxpbz0xXVtzZWN1ZW5jaWE9MV19&iad=%2F7rOgR8z%2BuK%2FTckyvLoFIzTgC6nvMKEglgV8CaiDwNa5RR6O554KXO6dIUc2LihK%2BgmA2KdbNP3qtZM0Fshl5Q%3D%3D',
                width: 35,
                height: 42
            },
            {
                img: Logo2,
                alt: 'Icono PDP',
                link: 'https://www.argentina.gob.ar/aaip/datospersonales',
                width: 70,
                height: 42
            },
            {
                img: Logo3,
                alt: 'Icono SSN',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 57,
                height: 42
            },
            {
                img: Logo4,
                alt: 'Icono godaddy',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 155,
                height: 42
            },
            {
                img: Logo5,
                alt: 'Icono econfianza',
                link: 'https://www.econfianza.org/ar/?c=minisitio&s=319',
                width: 110,
                height: 42
            }
        ];
    } else if (culture === 'es-py') {
        const Logo1 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo01.webp');
        const Logo2 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo02.webp');
        const Logo3 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo03.webp');
        const Logo4 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo04.webp');
        const Logo5 = require('static/img/cert-logos/es-ar/CECA_Footer_Logo05.webp');

        return [
            {
                img: Logo1,
                alt: 'Icono data fiscal',
                link: 'https://servicios1.afip.gov.ar/clavefiscal/qr/mobilePublicInfo.aspx?req=e1ttZXRob2Q9Z2V0UHVibGljSW5mb11bcGVyc29uYT0zMDcxMDc2OTg3M11bdGlwb2RvbWljaWxpbz0xXVtzZWN1ZW5jaWE9MV19&iad=%2F7rOgR8z%2BuK%2FTckyvLoFIzTgC6nvMKEglgV8CaiDwNa5RR6O554KXO6dIUc2LihK%2BgmA2KdbNP3qtZM0Fshl5Q%3D%3D',
                width: 35,
                height: 42
            },
            {
                img: Logo2,
                alt: 'Icono PDP',
                link: 'https://www.argentina.gob.ar/aaip/datospersonales',
                width: 70,
                height: 42
            },
            {
                img: Logo3,
                alt: 'Icono SSN',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 57,
                height: 42
            },
            {
                img: Logo4,
                alt: 'Icono godaddy',
                link: 'https://www.argentina.gob.ar/superintendencia-de-seguros',
                width: 155,
                height: 42
            },
            {
                img: Logo5,
                alt: 'Icono econfianza',
                link: 'https://www.econfianza.org/ar/?c=minisitio&s=319',
                width: 110,
                height: 42
            }
        ];
    }

    return null;
};

export default getCert;
